import { render, staticRenderFns } from "./flow-comment.vue?vue&type=template&id=1d3420d0&scoped=true&"
import script from "./flow-comment.vue?vue&type=script&lang=js&"
export * from "./flow-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3420d0",
  null
  
)

export default component.exports